import React, { Fragment, useRef, useEffect, memo } from 'react';
import styled from 'styled-components';
import { Title2 } from '../../../components/Typography';
import {
  ORDER_REFUNDED,
  ORDER_REJECTED,
  ORDER_SUBMITTED,
  ORDER_ACCEPTED,
  ORDER_COMPLETE,
  ORDER_ON_DELIVERY,
  ORDER_READY_TO_PICKUP,
  ORDER_OUT_FOR_DELIVERY,
  ORDER_DELIVERED,
  ORDER_DROPPING_OFF,
} from '../orderStatusTypes';
import OrderStatusModal2 from './OrderStatusModal2';
import { FlatButton } from '../../../components/Buttons';
import FeedbackModal from './FeedbackModal';
import Icon from './Icon';
import Slider from 'react-slick';
import appConfig from '../../../../app-config';
import {
  DELIVERY,
  PICKUP,
  DROPOFF,
} from '../../OrderSetting/orderSettingTypes';
import moment from 'moment';
import TrackButton from './TrackButton';
import calculateOrderReadyTime from '../utils/calculateOrderReadyTime';
const NextArrow = styled.div`
  @media (max-width: 1100px) {
    right: 10px !important;
  }
  @media (orientation: landscape) and (max-width: 1100px) {
    right: -20px !important;
  }
  @media (max-width: 786px) {
    display: none !important;
  }
`;

const PrevArrow = styled.div`
  @media (max-width: 786px) {
    display: none !important;
  }
`;

const OrderStatusContainer = styled.div`
  width: 532px;
  max-height: 400px;
  @media only screen and (min-width: 768px) {
    width: 450px;
  }
  @media (max-width: 480px) {
    max-width: 340px;
    max-height: 410px;
  }
`;
const OrderStatusWrapper = styled.div`
  width: 532px;
  height: 266px;
  padding: 16px 24px 52px;
  background: ${(props) => props.theme.orderStatusBackgroundColor};
  border-radius: 10px;
  cursor: ${(props) => !props.isForModal && 'pointer'};
  justify-content: center;
  &:hover {
    background: ${(props) =>
      !props.isForModal && props.theme.orderStatusBackgroundColorHover};
    transition: all 0.25s ease;
  }
  @media only screen and (min-width: 768px) {
    width: 450px;
    margin: 15px 0;
  }
  box-shadow: ${(props) => props.theme.orderStatusCartBoxShadow ?? 'none'};
  @media (max-width: 480px) {
    max-width: 340px;
    margin: 15px 0;
    height: 220px;
  }
`;
const FeedbackWrapper = styled.div`
  width: 100%;
  border-radius: 12px;
  padding: 12px 16px;
  background: #f7f7f7;
  grid-gap: 12px;
  display: grid;
  grid-template-columns: 0.7fr 0.3fr;
  margin: 15px 0;
  @media only screen and (min-width: 768px) {
    width: 450px;
  }
  @media (max-width: 480px) {
    display: block;
    max-width: 340px;
    margin-bottom: 20px;
  }
`;
const RateTextWrapper = styled.div`
  display: grid;
  grid-template-columns: 30px 1fr;
`;
const ButtonWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  @media (max-width: 480px) {
    margin-top: 10px;
  }
`;
const Wrapper = styled.div`
  margin: 32px auto 0 0;
  max-width: 480px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-wrap: wrap;
  @media (max-width: 479px) {
    padding: 5px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: ${(props) => (props.mini ? '4em' : '7em')};

  @media (max-width: 480px) {
    height: 5em;
  }
`;

const Title = styled(Title2)`
  color: ${(props) => props.theme.orderStatusTitleColor};
  margin-bottom: 10px;
`;

const Button = styled(FlatButton)`
  border-radius: 17.5px;
  padding: 7px 16px;
  background: ${(props) => props.theme.primaryButtonBackgroundColor};
  color: ${(props) => props.theme.primaryButtonFontColor};

  &:hover {
    background: ${(props) => props.theme.primaryButtonHoverColor};
    transition: all 0.25s ease;
  }
`;

const OrderPlacedTimeWrapper = styled.div`
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  padding-left: 5px;
`;
const OrderStatusMessage = styled.div`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  font-family: ${(props) => props.font || ''};
  color: ${(props) => props.customColor || 'black'};
`;

const OrderStatusSubMessage = styled.div`
  margin: 8px 0 0;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.02px;
  text-align: center;
  font-family: ${(props) => props.font || ''};
  color: ${(props) => props.customColor || '#737a87'};
`;
const Separator = styled.div`
  width: 3em;
  height: 4px;
  border-radius: 2px;
  background-color: ${(props) =>
    props.customColor || props.theme.orderStatusIconColor};
  margin: 0px 1em 0px 1em;
`;
const isOrderWithFirebaseUrl = (orderHistory, orderStatus) => {
  const orderHist = orderHistory.filter(
    (order) => order.order_id == orderStatus.orderId
  );

  if (orderHist[0]?.firebase_uri && orderHist[0]?.firebase_uri?.length !== 0) {
    return true;
  } else {
    return false;
  }
};
const SlideWrap = styled.div`
  margin-top: 10px;
  .slick-slide {
    padding: 0;
    margin-right: 10px;
  }
  .slick-list {
    margin: 0;
  }
  @media (min-width: 1800px) {
    .slick-list {
      min-width: 1600px !important;
    }
  }
  @media (min-width: 1550px) {
    .slick-list {
      min-width: 1470px !important;
    }
  }
  @media (min-width: 1400px) {
    .slick-list {
      min-width: 1170px !important;
    }
  }
  @media (orientation: landscape) and (max-width: 1100px) {
    .slick-list {
      width: 1255px !important;
    }
  }
`;
function OrderHistoryNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <NextArrow
      className={className}
      style={{
        ...style,
        display: 'block',
        background: '#fff',
        borderRadius: '50%',
        border: 'none',
        height: '40px',
        width: '40px',
        boxShadow: ' 0 2px 5px 0 rgba(59, 76, 112, 0.24)',
        top: props.feedbackRef.current ? '35%' : '45%',
        // right: '-10px',
        opacity: 1,
        fontSize: '16px',
        lineHeight: '40px',
        textAlign: 'center',
      }}
      onClick={onClick}
    />
  );
}

function OrderHistoryPrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <PrevArrow
      className={className}
      style={{
        ...style,
        display: 'block',
        background: '#fff',
        borderRadius: '50%',
        border: 'none',
        height: '40px',
        width: '40px',
        boxShadow: ' 0 2px 5px 0 rgba(59, 76, 112, 0.24)',
        top: props.feedbackRef.current ? '35%' : '45%',
        // left: '-20px',
        opacity: 1,
        lineHeight: '40px',
        textAlign: 'center',
        zIndex: '1',
      }}
      onClick={onClick}
    />
  );
}
const slideSettings = (feedbackRef) => {
  return {
    dots: false,
    infinite: false,
    speed: 600,
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    swipeToSlide: true,
    variableWidth: true,
    nextArrow: <OrderHistoryNextArrow feedbackRef={feedbackRef} />,
    prevArrow: <OrderHistoryPrevArrow feedbackRef={feedbackRef} />,
    rows: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          rows: 1,
          nextArrow: <OrderHistoryNextArrow feedbackRef={feedbackRef} />,
          prevArrow: <OrderHistoryPrevArrow feedbackRef={feedbackRef} />,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 1.7,
          slidesToScroll: 1,
          rows: 1,
          nextArrow: <OrderHistoryNextArrow feedbackRef={feedbackRef} />,
          prevArrow: <OrderHistoryPrevArrow feedbackRef={feedbackRef} />,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 1,
          nextArrow: <OrderHistoryNextArrow feedbackRef={feedbackRef} />,
          prevArrow: <OrderHistoryPrevArrow feedbackRef={feedbackRef} />,
        },
      },
    ],
  };
};
const SliderWrapper = ({ isMultiple, feedbackRef, children }) => {
  if (!isMultiple) {
    return <Wrapper>{children}</Wrapper>;
  }
  return (
    <SlideWrap>
      <Slider {...slideSettings(feedbackRef)}>{children}</Slider>
    </SlideWrap>
  );
};

const OrderStatus2 = ({
  orderStatusList,
  sendReview,
  feedbackModalIsVisible,
  openFeedbackModal,
  closeFeedbackModal,
  currency,
  is_tip_enabled,
  orderHistory,
  timeList,
  setTimeList,
  isFavoriteOpen,
  setIsFavoriteOpen,
  locations,
  feedbackModalData,
  setFeedbackModalData,
  orderStatusModalData,
  setOrderStatusModalData,
  displayComplete,
  setDisplayComplete,
}) => {
  const madRadishClients = ['madradish', 'madradish_catering'];
  const feedbackRef = useRef();
  const isMultiple = orderStatusList.length > 1;

  useEffect(() => {
    let newTimeList = [...timeList];
    const timer = setInterval(() => {
      orderStatusList.forEach((order, index) => {
        if (order.status === 2) {
          if (timeList.length > 0) {
            var duration = moment.duration(
              moment().diff(calculateOrderReadyTime(order))
            );
            var minutes = Math.round(duration.asMinutes());
            if (minutes > 29 && !orderStatusModalData && !isFavoriteOpen) {
              newTimeList[index].displayComplete = true;
              setTimeList(newTimeList);
            } else if (
              minutes < 30 &&
              !orderStatusModalData &&
              !isFavoriteOpen &&
              newTimeList[index].displayComplete
            ) {
              newTimeList[index].displayComplete = false;
              setTimeList(newTimeList);
            }
          }
        }
      });
    }, 5000);
    return () => {
      clearInterval(timer);
    };
  }, [orderStatusList]);
  const RenderOrderCompleteIcon = ({ orderType, status }) => {
    if (orderType === PICKUP)
      return (
        <>
          {status === ORDER_READY_TO_PICKUP ? (
            <>
              {appConfig.styleConfig?.orderStatusStep3ActiveIconPickup ? (
                <div>
                  <img
                    src={
                      appConfig.styleConfig?.orderStatusStep3ActiveIconPickup
                    }
                    alt='wait for confirmation'
                  />
                </div>
              ) : (
                <Icon className='fas fa-store' />
              )}
            </>
          ) : (
            <>
              {appConfig.styleConfig?.orderStatusStep3InactiveIconPickup ? (
                <div>
                  <img
                    src={
                      appConfig.styleConfig?.orderStatusStep3InactiveIconPickup
                    }
                    alt='wait for confirmation'
                  />
                </div>
              ) : (
                <Icon
                  className='fas fa-store'
                  style={{
                    color:
                      appConfig.styleConfig?.orderStatusDisableIconColor ||
                      appConfig.styleConfig?.primaryButtonDisabledColor,
                  }}
                />
              )}
            </>
          )}
        </>
      );

    if (orderType === DELIVERY)
      return (
        <>
          {status === ORDER_ON_DELIVERY ||
          status === ORDER_OUT_FOR_DELIVERY ||
          status === ORDER_DELIVERED ? (
            <>
              {appConfig.styleConfig?.orderStatusStep3ActiveIconDelivery ? (
                <div>
                  <img
                    src={
                      appConfig.styleConfig?.orderStatusStep3ActiveIconDelivery
                    }
                    alt='wait for confirmation'
                  />
                </div>
              ) : (
                <Icon className='fas fa-car-side' />
              )}
            </>
          ) : (
            <>
              {appConfig.styleConfig?.orderStatusStep3InactiveIconDelivery ? (
                <div>
                  <img
                    src={
                      appConfig.styleConfig
                        ?.orderStatusStep3InactiveIconDelivery
                    }
                    alt='wait for confirmation'
                  />
                </div>
              ) : (
                <Icon
                  className='fas fa-car-side'
                  style={{
                    color:
                      appConfig.styleConfig?.orderStatusDisableIconColor ||
                      appConfig.styleConfig?.primaryButtonDisabledColor,
                  }}
                />
              )}
            </>
          )}
        </>
      );

    if (orderType === DROPOFF)
      return (
        <>
          {status === ORDER_COMPLETE ? (
            <>
              {appConfig.styleConfig?.orderStatusStep3ActiveIconDelivery ? (
                <div>
                  <img
                    src={
                      appConfig.styleConfig?.orderStatusStep3ActiveIconDelivery
                    }
                    alt='wait for confirmation'
                  />
                </div>
              ) : (
                <Icon className='fas fa-shopping-bag' />
              )}
            </>
          ) : (
            <>
              {appConfig.styleConfig?.orderStatusStep3InactiveIconDelivery ? (
                <div>
                  <img
                    src={
                      appConfig.styleConfig
                        ?.orderStatusStep3InactiveIconDelivery
                    }
                    alt='wait for confirmation'
                  />
                </div>
              ) : (
                <Icon
                  className='fas fa-shopping-bag'
                  style={{
                    color:
                      appConfig.styleConfig?.orderStatusDisableIconColor ||
                      appConfig.styleConfig?.primaryButtonDisabledColor,
                  }}
                />
              )}
            </>
          )}
        </>
      );
  };

  const OrderStatusBody = ({
    orderType,
    status,
    businessName,
    orderReadyTime,
    deliveryTrackingURL,
    delay,
    index,
    statusMessage,
  }) => {
    return (
      <ContentWrapper>
        {status === ORDER_DELIVERED && (
          <Content>
            <Icon className='fas fa-badge-check' />
          </Content>
        )}
        {status === ORDER_COMPLETE &&
          timeList[index] &&
          timeList[index].displayComplete && (
            <Content>
              {appConfig.styleConfig?.orderStatusStepComplete ? (
                <div>
                  <img
                    src={appConfig.styleConfig?.orderStatusStepComplete}
                    alt='wait for confirmation'
                  />
                </div>
              ) : (
                <Icon className='fas fa-badge-check' />
              )}
            </Content>
          )}
        {(status === ORDER_REFUNDED || status === ORDER_REJECTED) && (
          <Content>
            {appConfig.styleConfig?.orderStatusStepRefund ? (
              <div>
                <img
                  src={appConfig.styleConfig?.orderStatusStepComplete}
                  alt='wait for confirmation'
                />
              </div>
            ) : (
              <Icon className='fas fa-exclamation-triangle' />
            )}
          </Content>
        )}
        {status === ORDER_SUBMITTED && (
          <Content>
            {appConfig.styleConfig?.orderStatusStep1ActiveIcon ? (
              <div>
                <img
                  src={appConfig.styleConfig?.orderStatusStep1ActiveIcon}
                  alt='wait for confirmation'
                />
              </div>
            ) : (
              <Icon className='fas fa-check-circle' />
            )}
            <Separator
              customColor={
                appConfig.styleConfig?.orderStatusHorizontalLineColor
              }
            />
            {appConfig.styleConfig?.orderStatusStep2InactiveIcon ? (
              <div>
                <img
                  src={appConfig.styleConfig?.orderStatusStep2InactiveIcon}
                  alt='wait for confirmation'
                />
              </div>
            ) : (
              <Icon
                className='fas fa-hat-chef'
                style={{
                  color:
                    appConfig.styleConfig?.orderStatusDisableIconColor ||
                    appConfig.styleConfig?.primaryButtonDisabledColor,
                }}
              />
            )}
            <Separator
              customColor={
                appConfig.styleConfig?.orderStatusHorizontalLineColor
              }
            />
            <RenderOrderCompleteIcon orderType={orderType} status={status} />
          </Content>
        )}
        {status === ORDER_ACCEPTED && (
          <Content>
            {appConfig.styleConfig?.orderStatusStep1InactiveIcon ? (
              <div>
                <img
                  src={appConfig.styleConfig?.orderStatusStep1InactiveIcon}
                  alt='wait for confirmation'
                />
              </div>
            ) : (
              <Icon
                className='fas fa-check-circle'
                style={{
                  color:
                    appConfig.styleConfig?.orderStatusDisableIconColor ||
                    appConfig.styleConfig?.primaryButtonDisabledColor,
                }}
              />
            )}
            <Separator
              customColor={
                appConfig.styleConfig?.orderStatusHorizontalLineColor
              }
            />
            {appConfig.styleConfig?.orderStatusStep2ActiveIcon ? (
              <div>
                <img
                  src={appConfig.styleConfig?.orderStatusStep2ActiveIcon}
                  alt='wait for confirmation'
                />
              </div>
            ) : (
              <Icon className='fas fa-hat-chef' />
            )}
            <Separator
              customColor={
                appConfig.styleConfig?.orderStatusHorizontalLineColor
              }
            />
            <RenderOrderCompleteIcon orderType={orderType} status={status} />
          </Content>
        )}

        {(status === ORDER_ON_DELIVERY ||
          status === ORDER_READY_TO_PICKUP ||
          status === ORDER_OUT_FOR_DELIVERY) &&
          timeList[index] &&
          !timeList[index].displayComplete && (
            <Content>
              {appConfig.styleConfig?.orderStatusStep1InactiveIcon ? (
                <div>
                  <img
                    src={appConfig.styleConfig?.orderStatusStep1InactiveIcon}
                    alt='wait for confirmation'
                  />
                </div>
              ) : (
                <Icon
                  className='fas fa-check-circle'
                  style={{
                    color:
                      appConfig.styleConfig?.orderStatusDisableIconColor ||
                      appConfig.styleConfig?.primaryButtonDisabledColor,
                  }}
                />
              )}
              <Separator
                customColor={
                  appConfig.styleConfig?.orderStatusHorizontalLineColor
                }
              />
              {appConfig.styleConfig?.orderStatusStep2InactiveIcon ? (
                <div>
                  <img
                    src={appConfig.styleConfig?.orderStatusStep2InactiveIcon}
                    alt='wait for confirmation'
                  />
                </div>
              ) : (
                <Icon
                  className='fas fa-hat-chef'
                  style={{
                    color:
                      appConfig.styleConfig?.orderStatusDisableIconColor ||
                      appConfig.styleConfig?.primaryButtonDisabledColor,
                  }}
                />
              )}
              <Separator
                customColor={
                  appConfig.styleConfig?.orderStatusHorizontalLineColor
                }
              />
              <RenderOrderCompleteIcon orderType={orderType} status={status} />
            </Content>
          )}

        <OrderStatusMessage
          customColor={appConfig.styleConfig.orderStatusTitleColor}
          font={appConfig.styleConfig.orderStatusMessageFont}
        >
          {status === ORDER_DELIVERED ? (
            <div>
              Your order has been delivered
              <div style={{ marginTop: '25px' }}>
                <TrackButton deliveryTrackingURL={deliveryTrackingURL} />
              </div>
            </div>
          ) : status === ORDER_SUBMITTED ? (
            <>
              Your order has been placed
              <OrderStatusSubMessage
                customColor={appConfig.styleConfig.orderStatusSubtitleColor}
                font={appConfig.styleConfig.orderStatusMessageFont}
              >
                Waiting for restaurant confirmation…
              </OrderStatusSubMessage>
            </>
          ) : status === ORDER_ACCEPTED && delay === 0 ? (
            <>
              Your order is being prepared
              <OrderStatusSubMessage
                customColor={appConfig.styleConfig.orderStatusSubtitleColor}
                font={appConfig.styleConfig.orderStatusMessageFont}
              >
                {`It will be ready by ${orderReadyTime}`}
              </OrderStatusSubMessage>
            </>
          ) : status === ORDER_ACCEPTED && delay > 0 ? (
            <>
              Your order is being prepared
              <OrderStatusSubMessage
                customColor={appConfig.styleConfig.orderStatusSubtitleColor}
                font={appConfig.styleConfig.orderStatusMessageFont}
              >
                {`It will be ready by ${orderReadyTime}. Please contact the store for more information.`}
              </OrderStatusSubMessage>
            </>
          ) : status === ORDER_READY_TO_PICKUP &&
            orderType === 'pickup' &&
            timeList[index] &&
            !timeList[index].displayComplete ? (
            <>
              Your order is ready for pickup
              <OrderStatusSubMessage
                customColor={appConfig.styleConfig.orderStatusSubtitleColor}
                font={appConfig.styleConfig.orderStatusMessageFont}
              >
                {`at ${businessName}`}
              </OrderStatusSubMessage>
            </>
          ) : (status === ORDER_ON_DELIVERY ||
              status === ORDER_OUT_FOR_DELIVERY) &&
            orderType === 'delivery' &&
            !timeList?.[index]?.displayComplete ? (
            <>
              {appConfig.styleConfig?.deliveryOutOnLine1 ??
                'Your order is out for delivery'}
              {deliveryTrackingURL ? (
                <div style={{ marginTop: '25px' }}>
                  <TrackButton deliveryTrackingURL={deliveryTrackingURL} />
                </div>
              ) : (
                <OrderStatusSubMessage
                  customColor={appConfig.styleConfig.orderStatusSubtitleColor}
                  font={appConfig.styleConfig.orderStatusMessageFont}
                >
                  {appConfig.styleConfig?.deliveryOutOnLine2
                    ? `${appConfig.styleConfig.deliveryOutOnLine2} ${orderReadyTime}`
                    : `It will be delivered by ${orderReadyTime}`}
                  {/* {`It will be delivered by ${orderReadyTime}`} */}
                </OrderStatusSubMessage>
              )}
            </>
          ) : status === ORDER_DROPPING_OFF &&
            orderType === 'drop_off' &&
            !timeList?.[index]?.displayComplete ? (
            <>
              {appConfig.styleConfig?.deliveryOutOnLine1 ??
                'Bringing the order to you'}
              {deliveryTrackingURL ? (
                <div style={{ marginTop: '25px' }}>
                  <TrackButton deliveryTrackingURL={deliveryTrackingURL} />
                </div>
              ) : (
                <OrderStatusSubMessage
                  customColor={appConfig.styleConfig.orderStatusSubtitleColor}
                  font={appConfig.styleConfig.orderStatusMessageFont}
                >
                  {appConfig.styleConfig?.deliveryOutOnLine2
                    ? `${appConfig.styleConfig.deliveryOutOnLine2} ${orderReadyTime}`
                    : `It will be brought to you by ${orderReadyTime}`}
                  {/* {`It will be delivered by ${orderReadyTime}`} */}
                </OrderStatusSubMessage>
              )}
            </>
          ) : status === ORDER_REFUNDED || status === ORDER_REJECTED ? (
            <div>{statusMessage}</div>
          ) : status === ORDER_COMPLETE &&
            timeList?.[index]?.displayComplete ? (
            <div>Your order is complete!</div>
          ) : null}
        </OrderStatusMessage>
      </ContentWrapper>
    );
  };
  return (
    <Fragment>
      <SliderWrapper isMultiple={isMultiple} feedbackRef={feedbackRef}>
        {orderStatusList.map((orderStatus, index) => {
          const status = orderStatus.status;
          const businessName = orderStatus.business_name;
          const orderType = orderStatus.order_type;
          const orderReadyTime = calculateOrderReadyTime(orderStatus, false);
          const deliveryTrackingURL = orderStatus.delivery_tracking_url;
          const delay = orderStatus.delay;
          const statusMessage = orderStatus?.status_change_message
            ? orderStatus.status_change_message
            : ' Unfortunately, we cannot fulfill your order at this time. Your order will be refunded.';

          return (
            <OrderStatusContainer key={index}>
              <OrderStatusWrapper
                onClick={() => {
                  isOrderWithFirebaseUrl(orderHistory, orderStatus);
                  setDisplayComplete(timeList[index].displayComplete);
                  setOrderStatusModalData(orderStatus);
                }}
                isForModal={
                  isOrderWithFirebaseUrl(orderHistory, orderStatus)
                    ? false
                    : true
                }
                key={index}
              >
                <Title id='OrderStatus-Title'>Order Status</Title>
                <OrderStatusBody
                  orderType={orderType}
                  status={status}
                  businessName={businessName}
                  orderReadyTime={orderReadyTime}
                  deliveryTrackingURL={deliveryTrackingURL}
                  delay={delay}
                  index={index}
                  statusMessage={statusMessage}
                />
              </OrderStatusWrapper>
              {orderStatusList?.length > 1 && (
                <OrderPlacedTimeWrapper>
                  {`Placed on: ${moment(orderStatus?.order_created_at).format(
                    'MMMM Do, hh:mm A'
                  )}`}
                </OrderPlacedTimeWrapper>
              )}
              {!madRadishClients.includes(appConfig.appSource) &&
              (status === ORDER_COMPLETE || status === ORDER_ON_DELIVERY) ? (
                <FeedbackWrapper ref={feedbackRef}>
                  <RateTextWrapper>
                    <i
                      className='fas fa-user-headset'
                      style={{ lineHeight: '40px' }}
                    ></i>
                    <span style={{ display: 'inline-block' }}>
                      Tell us how we did today. Your feedback helps us improve.
                    </span>
                  </RateTextWrapper>
                  <ButtonWrapper>
                    <Button
                      id='OrderStatus-FeedbackButton'
                      onClick={() => {
                        setFeedbackModalData(orderStatus);
                        setIsFavoriteOpen(true);
                      }}
                    >
                      Rate your order
                    </Button>
                  </ButtonWrapper>
                </FeedbackWrapper>
              ) : null}
            </OrderStatusContainer>
          );
        })}
      </SliderWrapper>
      <FeedbackModal
        feedbackModalData={feedbackModalData}
        setFeedbackModalData={setFeedbackModalData}
        sendReview={sendReview}
        feedbackModalIsVisible={feedbackModalIsVisible}
        openFeedbackModal={openFeedbackModal}
        closeFeedbackModal={closeFeedbackModal}
        isFavoriteOpen={isFavoriteOpen}
        setIsFavoriteOpen={setIsFavoriteOpen}
      />
      <OrderStatusModal2
        orderStatusModalData={orderStatusModalData}
        setOrderStatusModalData={setOrderStatusModalData}
        isMultiple={isMultiple}
        currency={currency}
        is_tip_enabled={is_tip_enabled}
        displayComplete={displayComplete}
        locations={locations}
      />
    </Fragment>
  );
};

export default memo(OrderStatus2);
